import { Button } from "./ui/button"
import { Separator } from "./ui/separator"
import { SidebarTrigger } from "./ui/sidebar"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { useBreadcrumbStore } from "@/client/stores/breadcrumb"
import { Fragment } from "react"
import { DataScopeSwitch } from "./data-scope-switch"

export function SiteHeader({ title = 'Dashboard', description = '' }: { title?: string; description?: string }) {
  const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs)

  return (
    <header className="sticky top-0 z-30 flex h-20 shrink-0 items-center gap-2 border-b bg-background transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        {breadcrumbs.length > 0 ? (
          <div className="flex-1 min-w-0 overflow-hidden">
            <Breadcrumb>
              <BreadcrumbList className="flex-nowrap">
                {breadcrumbs.map((item, index) => {
                  const isCurrent = index === breadcrumbs.length - 1
                  return (
                    <Fragment key={index}>
                      <BreadcrumbItem className="truncate">
                        {!isCurrent && item.href ? (
                          <BreadcrumbLink href={item.href} className="truncate max-w-[150px] inline-block">
                            {item.label}
                          </BreadcrumbLink>
                        ) : isCurrent ? (
                          <BreadcrumbPage className="truncate max-w-[240px] inline-block text-base font-semibold text-foreground">
                            {item.label}
                          </BreadcrumbPage>
                        ) : (
                          <BreadcrumbPage className="truncate max-w-[150px] inline-block">
                            {item.label}
                          </BreadcrumbPage>
                        )}
                      </BreadcrumbItem>
                      {!isCurrent && <BreadcrumbSeparator />}
                    </Fragment>
                  )
                })}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        ) : (
          <div className="flex-1 min-w-0">
            <h1 className="text-base font-semibold truncate">{title}</h1>
            {description ? (
              <p className="text-sm text-foreground/50 truncate">{description}</p>
            ) : null}
          </div>
        )}
        <div className="ml-auto flex items-center gap-2 py-2">
          <DataScopeSwitch />
          <Button variant="ghost" asChild size="sm" className="hidden sm:flex dark:text-foreground">
            Logout
          </Button>
        </div>
      </div>
    </header>
  )
}
